import { UseFormReturn } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface MinistryBackgroundStepProps {
  form: UseFormReturn<any>;
  onNext: () => void;
  onBack: () => void;
}

export const MinistryBackgroundStep = ({ form, onNext, onBack }: MinistryBackgroundStepProps) => {
  return (
    <Form {...form}>
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Ministry & Faith Background</h3>
      
      <FormField
        control={form.control}
        name="churchAffiliation"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Current Church Affiliation *</FormLabel>
            <FormControl>
              <Input {...field} placeholder="Church name and location" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="pastorName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Pastor's Name *</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="pastorContact"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Pastor's Contact (Phone or Email) *</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="yearsAsChristian"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Years as a Christian *</FormLabel>
            <FormControl>
              <Input type="number" {...field} min="0" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="ministryInvolvement"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Current Ministry Involvement (if any)</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                placeholder="Describe any current ministry roles, volunteer work, or church activities"
                rows={3}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="programInterestReason"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Why are you interested in this program? *</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                placeholder="Please provide a detailed explanation (minimum 20 characters)"
                rows={4}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="educationUsePlan"
        render={({ field }) => (
          <FormItem>
            <FormLabel>How do you plan to use your education? *</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                placeholder="Describe your goals and how you plan to apply what you learn (minimum 20 characters)"
                rows={4}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

        <div className="flex justify-between pt-4">
          <Button variant="outline" onClick={onBack}>Back</Button>
          <Button onClick={onNext}>Next</Button>
        </div>
      </div>
    </Form>
  );
};
